import camelCase from 'lodash/camelCase';
import { SwitchField } from '@scalingworks/react-admin-ui';
import { InputProps } from '../props';
import { useEffect } from 'react';

export const FormSwitchField = ({ input: { item, register, setValue, watch } }: InputProps) => {
  const { title, name, required, placeholder, defaultValue, props, hint, onChange } = item;
  const formName = camelCase(name || title);

  // Set initial value when component mounts
  useEffect(() => {
    if (defaultValue !== undefined) {
      setValue(formName, defaultValue);
    }
  }, [defaultValue, formName, setValue]);

  register(formName, { required });
  const watchChecked = watch(formName);

  return (
    <SwitchField
      {...props}
      required={required}
      label={title}
      layout="responsive"
      placeholder={placeholder}
      defaultChecked={defaultValue as boolean}
      checked={watchChecked}
      value={watchChecked}
      hint={hint}
      onCheckedChange={(val) => {
        setValue(formName, val);
        onChange && onChange(val);
      }}
    />
  );
};
